"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformTimeWithOffsetToUTC = void 0;
const date_fns_tz_1 = require("date-fns-tz");
function transformTimeWithOffsetToUTC(date) {
    const indexOfPlusTZ = date.lastIndexOf("+");
    const indexOfMinusTZ = date.lastIndexOf("-");
    const indexOfZFormat = date.lastIndexOf("Z");
    const indexOfTZSign = indexOfPlusTZ > -1 ? indexOfPlusTZ : indexOfMinusTZ > 10 ? indexOfMinusTZ : indexOfZFormat;
    const extractedDate = date.substring(0, indexOfTZSign);
    // Valid form of RFC is without timezone but with Z at the end
    const extractedTimezone = indexOfZFormat > -1 ? "+00:00" : date.substring(indexOfTZSign);
    const basicDate = new Date(extractedDate);
    // remove offset that new Date() adds to basicDate
    const timezoneOffset = (0, date_fns_tz_1.getTimezoneOffset)(extractedTimezone, basicDate) + basicDate.getTimezoneOffset() * 1000 * 60;
    const utcDate = new Date(basicDate.getTime() - timezoneOffset);
    if (isNaN(utcDate.getTime())) {
        throw new Error(`Invalid date after parsing: "${date}". Date: "${extractedDate}", Timezone: "${extractedTimezone}"`);
    }
    return utcDate;
}
exports.transformTimeWithOffsetToUTC = transformTimeWithOffsetToUTC;
//# sourceMappingURL=transformTimeWithOffsetToUTC.js.map